require('../../../modules/es.array.for-each');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').forEach;